<template>
  <div>
    <b-form-group
      id="input-group-3"
      label="Tipo de Proceso:"
      label-for="input-3"
    >
      <b-form-select
        id="input-1"
        :value="form.process_type"
        :options="process_types"
        @input="updateProcessType"
        value-field="id"
        required
      ></b-form-select>
    </b-form-group>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "ProcessData",
  props: {},
  mounted() {
    this.getProcessTypes();
  },
  data() {
    return {
      form: {
        email: "",
        name: "",
        food: null,
        checked: []
      },
      process_types: [{ text: "Cargando...", value: null }],
      show: true
    };
  },
  computed: {
    ...mapState("bagnoProcessModule", ["form.process_type"])
  },
  methods: {
    updateProcessType(e) {
      this.$store.commit("bagnoProcessModule/updateProcessType", e);
    },
    async getProcessTypes() {
      const thisV = this;
      thisV.$emit("update-loading", true);
      try {
        const response = await thisV.$axios({
          method: "GET",
          url: "bagno/process-types/"
        });
        thisV.$emit("update-loading", false);
        thisV.process_types = response.data;
      } catch (error) {
        console.log(error);
        thisV.$emit("update-loading", false);
      }
    }
  }
};
</script>

<style scoped></style>
